var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"app-footer custom-footer"},[_c('span',[_c('a',{attrs:{"href":"#"}},[_vm._v("Market Scan")]),_vm._v(" © "+_vm._s(_vm.currentYear))]),_vm._v(" "),_c('span',{staticClass:"ml-auto"})])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/components/Footer.vue?vue&type=template&id=0ba8b7a8&
// module id = null
// module chunks = 